import React from 'react';
import Dialog from "Components/Core/Dialog";
import DialogAddLink from './DialogAddLink';
import DialogAddText from './DialogAddText';
import DialogNewImage from './DialogNewImage';
import FormSelectIcon from 'Components/Core/Form/FormSelectIcon';
import FormSelectText from 'Components/Core/Form/FormSelectText';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';
import Module from 'Components/Core/Module';
import NewAnswer from './NewAnswer';
import NewThread from './NewThread';
import PostingDay from './PostingDay';
import PostingMember from './PostingMember';
import PostingList from './PostingList';
import Postings from './Postings';
import PostingSearch from './PostingSearch';
import NewThreadShort from './NewThreadShort';
import 'CSS/Forum/Forum.css'
import './Postings.css'

export default function Forum(props) {

	const x = props.x;

	// IDs der integrierten Dialoge
	const answerId = props.id + '-answer';
	const newThreadId = props.id + '-new-thread';
	const searchId = props.id + '-search';
	const memberId = props.id + '-member';
	const currentId = props.id + '-current';
	const favoritsId = props.id + '-favorits';
	const postingDayId = props.id + '-posting-day';
	const postingMemberId = props.id + '-select-member-postings';
	const selectTopicId = props.id + '-select-topic';
	const dialogIds = [answerId, newThreadId, searchId, currentId, favoritsId, postingDayId];
	const newImageId = props.id + '-new-image';
	const layoutSettingsId = props.id + '-select-layout-settings';
	const closeButton = (props.id === 'forum') ? false : true;
	let currentLayoutSettingIcon = '';
	// const [title, setTitle] = React.useState(props.title);
	const title = props.title;
	const [answerTo, setAnswerTo] = React.useState(0);
	const [hideContent, setHideContent] = React.useState(x.was.forumHideContent);
	const [hideDiscussion, setHideDiscussion] = React.useState(x.was.forumHideDiscussion);
	const [hideImages, setHideImages] = React.useState(x.was.forumHideImages);
	const [hideAvatar, setHideAvatar] = React.useState(x.was.forumHideAvatar);
	const [hideDate, setHideDate] = React.useState(x.was.forumHideDate);
	const [memberColored, setMemberColored] = React.useState(x.was.forumMemberColored);
	const [fontBold, setFontBold] = React.useState(x.was.forumFontBold);
	const [forumScroll, setForumScroll] = React.useState(x.was.forumScroll);
	const [typingName, setTypingName] = React.useState(null);
	const typingTimer = React.useRef(null);

	const renderCount = React.useRef(1);
	const postingCount = React.useRef(null);
	const [postingDisplayCount, setPostingDisplayCount] = React.useState(null);
	const [composerFocused, setComposerFocused] = React.useState(false);

	React.useEffect(() => {
		if (x.wam.current !== props.id) setComposerFocused(false);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [x.wam, props.id]);

	x.wam[props.id].setTyping = (name) => {
		setTypingName(name);
		clearTimeout(typingTimer.current);
		typingTimer.current = setTimeout(() => setTypingName(null), 4000);
	};

	const postingListCurrent = [];										// Hier werden Zeiger auf die benötigten Funktionen der PostingList-Komponenten gespeichert
	const postingListFavorit = [];										// Hier werden Zeiger auf die benötigten Funktionen der PostingList-Komponenten gespeichert

	let updateLastPostingNoRead = (value) => { };

	React.useEffect(() => {
		if (renderCount.current === 1) {
			window.webapp.system.webAppLoaded();
			if (props.id === 'forum') x.wam[props.id].show();
		}
	}, [props.id, x.wam]);

	React.useEffect(() => {
		const handleKey = (event) => {
			if (event.keyCode === 27) {
				console.log('ESC');
				x.wad.hideAll();
				return;
			}
			// Focus-folgt-Tastatur: Wird in diesem (aktiven) Forum ohne fokussiertes Eingabefeld
			// getippt, soll die Taste automatisch ins "Neuer Beitrag"-Feld weitergeleitet werden,
			// statt ins Leere zu gehen.
			if (x.wam.current !== props.id) return;
			const active = document.activeElement;
			const isInputFocused = active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA' || active.isContentEditable);
			if (isInputFocused || event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return;
			const instanceId = x.was.chatMode ? props.id : 'default';
			const fieldWafId = 'new-thread-short-' + instanceId;
			const inputEl = document.getElementById(fieldWafId + '-new-posting-short');
			if (inputEl === null) return;
			event.preventDefault();
			const currentVal = x.waf.get(fieldWafId, 'new-posting-short');
			const newVal = currentVal + event.key;
			x.waf.set(fieldWafId, 'new-posting-short', newVal);
			// new-posting-short ist ein kontrolliertes Input (value={newThread} in PostingElement.js) -
			// ohne das Update des React-States wuerde der naechste Render den Wert wieder verwerfen.
			x.was.setNewThreadShort(newVal);
			inputEl.focus();
			requestAnimationFrame(() => {
				inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
			});
		}
		window.addEventListener("keydown", handleKey);
		if (renderCount.current === 1) {
			x.wam[props.id].postings.load();
		}
		renderCount.current++;
		return () => {
			// x.was.delWatchKey(wafId);
			window.removeEventListener("keydown", handleKey);
		}
	});

	function postingsUnreadReset(loadPostings = false) {
		closeDialogs();
		const url = 'Backend/webapp.php?module=Posting&task=PostingsUnreadReset&forumId=' + props.forumId + '&postingCount=' + postingCount.current;
		x.was.axGet(url, (result) => {
			if (result.data.returncode === 1) {
				x.was.postingsUnread[props.id] = 0;
				x.was.postingsLastUnread[props.id] = 0;
				x.was.loadActiveMember();
				x.was.send('read-posting', { "memberid": x.was.memberId, "module": props.id });
				updateLastPostingNoRead(result.data.content['posting-last-no']);
				x.was.updatePostingsUnread();
				if (loadPostings) x.wam[props.id].postings.load();
			}
		});
	}

	/* Funktionen der Dialoge
		Über die Objekte "newThread", "newAnswer", "posting" und "search" stehen die dortigen Funktionen extern zur Verfügung.  
	*/
	if (typeof x.wam[props.id].newPostings == 'undefined') {
		x.wam.init(props.id, {
			"init": init,
			"newThread": {},
			"newAnswer": {},
			"postings": {},
			"current": {},
			"search": {},
			"newPostings": false,
			"lastPostingNo": 0,
			"quote": '',
			"quotePosting": 0,
			"getCurrentPostingCount": getCurrentPostingCount,
			"getCurrentTopicId": getCurrentTopicId,
			"moduleType": "forum",
			"title": props.title,
			"scrollTop": scrollTop,
			"debug": debug,
			"closeDialogs": closeDialogs,
			"onDialogClose": onDialogClose,
			"showDialogAnswer": showDialogAnswer,
			"showDialogNewThread": showDialogNewThread,
			"showMemberPostings": showMemberPostings,

		});
	}


	x.wad.init(answerId);
	x.wad.init(newThreadId);
	x.wad.init(searchId);

	function init() {
		if (x.wam[props.id].newPostings) {
			x.wam[props.id].postings.load();
			x.wam[props.id].newPostings = false;
		}
		const conversationalPartner = x.wau.getConversationalPartner(props.id);
		if (typeof x.was.postingsUnreadHint[conversationalPartner] !== 'undefined' && x.wah.isVisible(x.was.postingsUnreadHint[conversationalPartner])) {
			x.wah.removeHint(null, x.was.postingsUnreadHint[conversationalPartner]);
		}
	}

	function debug() {
		const module = props.id + ' - ';
		console.log(module);
	}

	function setLayoutSettingsData() {
		const layoutSettings = [];
		const icons = {
			scroll: 'bi-arrow-left-right',
			images: 'bi-image',
			content: 'bi-text-paragraph',
			discussion: 'bi-chat-square-text',
			avatar: 'bi-person-circle',
			date: 'bi-calendar3',
			memberColored: 'bi-palette',
			font: 'bi-type-bold',
			startModule: 'bi-house-gear',
		};

		addData('startModule', 'Als Startforum festlegen');
		layoutSettings.push({ "id": '__divider__', "icon": '', "name": '' });
		(forumScroll === 1) ? addData('scroll', 'Horizontale Ansicht umbrechen') : addData('scroll', 'Horizontale Ansicht scrollen');
		(hideImages === 1) ? addData('images', 'Bilder anzeigen') : addData('images', 'Bilder ausblenden');
		(hideContent === 1) ? addData('content', 'Inhalte anzeigen') : addData('content', 'Inhalte ausblenden');
		(hideDiscussion === 1) ? addData('discussion', 'Unterhaltung anzeigen') : addData('discussion', 'Unterhaltung ausblenden');
		(hideAvatar === 1) ? addData('avatar', 'Avatar anzeigen') : addData('avatar', 'Avatar ausblenden');
		(hideDate === 1) ? addData('date', 'Datum anzeigen') : addData('date', 'Datum ausblenden');
		(memberColored === 1) ? addData('memberColored', 'Name des Verfassers schwarz anzeigen') : addData('memberColored', 'Name des Verfassers farbig anzeigen');
		(fontBold === 1) ? addData('font', 'Normale Schrift') : addData('font', 'Fette Schrift');

		return layoutSettings;

		function addData(key, name) {
			layoutSettings.push({ "id": key, "icon": icons[key], "name": name });
		}

	}

	function setAsStartModule() {
		x.was.axPost('Backend/webapp.php?module=Member&task=SaveMemberStartModule', { "forumId": props.forumId }, (result) => {
			if (result.data.returncode === 1) {
				x.was.startModule = props.forumId;
				x.wah.addHint('Dieses Forum wurde als Startforum festgelegt.');
			}
			else {
				x.wah.addHint('Startforum konnte nicht gespeichert werden!', true);
			}
		});
	}

	function postingQuote(event, posting, postdate, membername) {
		event.preventDefault();
		const quote = makeQuote(posting, postdate, membername);
		showDialogNewThread(quote, 0);
		// console.log(quote);
	}

	async function copyToClipboard(event, posting, postdate, membername) {
		event.preventDefault();
		try {
			await navigator.clipboard.writeText(makeQuote(posting, postdate, membername));
			event.preventDefault();
			x.wah.addHint('Der Beitrag wurde in die Zwischenablage kopiert...', true);
		} catch (error) {
			console.error(error.message);
		}
	}

	function makeQuote(posting, postdate, membername) {
		// const quote = '' + String.fromCharCode(10) + '[quote]' + membername + ' ' + postdate + String.fromCharCode(10) + posting + String.fromCharCode(10) + '[/quote]' + String.fromCharCode(10) 
		const quote = '[quote]' + membername + ' ' + postdate + String.fromCharCode(10) + posting + String.fromCharCode(10) + '[/quote]' + String.fromCharCode(10)
		console.log(membername);
		return quote;
	}

	function closeDialogs(currentDialog = '') {
		dialogIds.forEach(
			function (dialog) {
				if (dialog !== currentDialog) {
					x.wad[dialog].hide();
				}
			}
		);
	}

	function getCurrentPostingCount() {
		x.wam[props.id].currentPostingNo = (x.wam[props.id].currentPostingNo === 0) ? (x.wam[props.id].lastPostingNo - 1) : x.wam[props.id].currentPostingNo;
		return x.wam[props.id].lastPostingNo - x.wam[props.id].currentPostingNo;
	}

	function onDialogClose() {
	}

	function toggleView() {
		setHideContent(prev => (prev === 1) ? 0 : 1);
		// x.wam[props.id].postings.render();
	}

	function toggleDiscussion() {
		setHideDiscussion(prev => (prev === 1) ? 0 : 1);
	}

	function toggleImages() {
		setHideImages(prev => (prev === 1) ? 0 : 1);
	}

	function toggleAvatar() {
		setHideAvatar(prev => (prev === 1) ? 0 : 1);
	}

	function toggleScroll() {
		setForumScroll(prev => (prev === 1) ? 0 : 1);
	}

	function toggleDate() {
		setHideDate(prev => (prev === 1) ? 0 : 1);
	}

	function toggleMemberColored() {
		setMemberColored(prev => (prev === 1) ? 0 : 1);
	}

	function toggleFont() {
		setFontBold(prev => (prev === 1) ? 0 : 1);
	}


	function toggleCurrent() {
		closeDialogs(currentId);
		x.wad[currentId].toggleDisplay();
		if (x.wad[currentId].isVisible) {
			// x.wam[props.id].loadCurrentPostings()
			postingListCurrent.load();
		}
	}

	function toggleFavorits() {
		closeDialogs(favoritsId);
		x.wad[favoritsId].toggleDisplay();
		if (x.wad[favoritsId].isVisible) {
			postingListFavorit.load();
		}
	}

	function toggleMember() {
		closeDialogs(memberId);
		x.wad[memberId].toggleDisplay();
	}

	function toggleSearch() {
		x.wad.hideAll(searchId);
		x.wad[searchId].toggleDisplay(() => { x.waf.focus(searchId, 'search') });
	}

	function togglePostingDay() {
		closeDialogs(postingDayId);
		x.wad[postingDayId].toggleDisplay();
	}

	function showDialogNewThread(quote = '', curPos = -1) {
		closeDialogs();
		// Neuer Thread-Dialog anzeigen
		x.wad[answerId].hide();
		if (quote !== '') {
			x.waf.set(newThreadId, 'posting', quote);
			x.wau.postingBackup(newThreadId, 'posting', quote);
		}
		x.wad[newThreadId].init();
		x.wad[newThreadId].show(() => { x.waf.focus(newThreadId, 'posting') });
		if (curPos > -1) {
			x.waf.setCursorPos(newThreadId, 'posting', curPos, curPos);
		}
	}

	function showDialogAnswer(reloadPostings, topicId, topicName, postingNo, visible, posting, memberId, memberName, postingDate) {
		closeDialogs();
		x.wau.postingRestore(answerId, postingNo);
		x.waf[answerId].addSend['answerto'] = postingNo;
		x.waf.set(answerId, 'base-posting', posting);
		setAnswerTo(postingNo);
		x.wad[answerId].memberId = memberId;
		x.wad[answerId].memberName = memberName;
		x.wad[answerId].postingNo = postingNo;
		x.wad[answerId].topicId = topicId;
		x.wad[answerId].topicName = topicName;
		x.wad[answerId].postingDate = postingDate;
		x.wad[answerId].posting = posting;
		x.wad[answerId].visible = visible;
		// x.waf.set(props.id + '-form-current-topic', props.id + '-select-set-topic' + '-form', topicName);
		x.waf.set(props.id + '-form-current-topic', `${props.id}-select-set-topic-form`, topicName);
		x.wad[answerId].init(postingNo, visible, memberId); // Wird in PostingContextMenu.js ausgeführt
		// x.wad[answerId].postingRestore();

		x.wad[answerId].show(() => {
			x.waf.focus(answerId, 'posting');
			// x.wad[answerId].postingRestore();
		});
		x.wad[answerId].reloadPostings = reloadPostings;
	}

	function showMemberPostings(memberId, memberName) {
		closeDialogs();
		toggleMember();
		x.wad[postingMemberId + '-dialog'].setValue(memberId, memberName);
	}

	function expandComposer() {
		const wafIdNewThread = props.id + '-new-thread';
		let newPostingShort = '';
		try {
			newPostingShort = x.waf.get('new-thread-short-' + props.id, 'new-posting-short');
		}
		catch (error) {
			newPostingShort = '';
		}
		const postingBackup = x.wau.postingRestore(wafIdNewThread, 0);
		if ((postingBackup === null || postingBackup.trim() === '') && newPostingShort !== '') {
			x.wau.postingBackup(wafIdNewThread, 0, newPostingShort);
			x.waf.set(wafIdNewThread, 'posting', newPostingShort);
		}
		x.wam[props.id].showDialogNewThread();
		x.wam.activate(props.id);
	}

	function scrollTop() {
		// Soll immer zum NEUESTEN Beitrag springen: im Chat-Modus ans Ende (dort steht der
		// neueste Beitrag), sonst an den Anfang (dort steht im Forum der neueste Thread).
		if (x.was.chatMode) {
			x.wam[props.id].postings.scrollToLatest();
		}
		else {
			x.$('#postings-' + props.id + '-postings').animate({ scrollTop: 0 }, 600);
			x.wam[props.id].postings.load();
		}
	}

	function getCurrentTopicId() {
		return x.waf.getKey('form-current-topic', selectTopicId + '-form');
	}

	function getTopicList() {
		const forumTopics = x.was.topics.filter(
			(topic) => topic.forumid === null || topic.forumid === 0 || String(topic.forumid) === String(props.id)
		);
		const topicList = [{ 'id': 0, 'name': 'Kein Filter' }].concat(forumTopics);
		return topicList;
	}

	const openProfileTag =
		(typeof props.memberName !== 'undefined' && props.memberName !== '') ?
			<span className={` bi bi-person-fill module-icon  `} title="Profil anzeigen" onClick={() => x.wam.openProfile(props.memberId, props.memberName)}>
			</span>
			:
			null

	const titleToolbarClass =
		(typeof props.memberName !== 'undefined' && props.memberName !== '') ?
			"module-title-toolbar-member"
			:
			"module-title-toolbar"


	const selectTopicTag =
		<FormSelectText
			id={selectTopicId}
			iconMode={false}
			wafId="form-current-topic"
			name="topicid"
			componentId={x.wau.getComponentId()}
			moduleId={props.id}
			x={x}
			classes="form-select-topic"
			default=""
			defaultKey={0}
			title="Alle Themen"
			alwaysShowSelection={false}
			afterSelect={(key, value) => {
				x.wam[props.id].postings.load();

			}}
			resetIcon={false}
		/>


	return (

		<React.Fragment>
			<Module id={props.id}
				x={x}
				title={title}
				classes={`module-forum `}
				display={props.display}
				displayTitle="d-block"
				titleToolbar=<span className={`${titleToolbarClass}`}>
					{openProfileTag}
					{selectTopicTag}
				</span>
				closeButton={closeButton}>
				<div className="forum-body">
					<div className="forum-toolbar-vertical">
						<span
							onClick={() => { postingsUnreadReset() }}
							title="Ungelesene Beiträge auf 0 stellen"
						>
							<span
								className={` bi bi-check2-square module-icon new-postings-icon `}

							/>
						</span>
						<span className='module-icon-group' onClick={e => toggleCurrent()}>
							<span
								className={` bi bi-bell module-icon ${(x.was.postingsUnread[props.id] > 0) ? "module-icon-clicked" : ""} `}
								title={"Neueste Beiträge " + ((x.was.postingsUnread[props.id] > 0) ? "(" + x.was.postingsUnread[props.id] + " ungelesen)" : "")} >
							</span>
						</span>
						<span className={` bi bi-star-fill module-icon `}
							title="Favoriten anzeigen"
							onClick={e => toggleFavorits()}>
						</span>
						<span className={` bi ${x.was.chatMode ? 'bi-align-bottom' : 'bi-align-top'} module-icon `}
							title={x.was.chatMode ? 'Zum neuesten Beitrag springen' : 'Zum Anfang der Beiträge scrollen'}
							onClick={e => scrollTop()}>
						</span>
						<span className={` bi bi-search module-icon `}
							title="Suchen"
							onClick={e => toggleSearch()}>
						</span>
						<span className={` bi bi-calendar-date module-icon `}
							title="Einen gesamten Tag anzeigen"
							onClick={e => togglePostingDay()}>
						</span>
						<span className={` bi bi-person module-icon `}
							title="Beiträge eines Mitglieds anzeigen"
							onClick={e => toggleMember()}>
						</span>

						<FormSelectIcon
							id={layoutSettingsId}
							wafId={layoutSettingsId}
							componentId={x.wau.getComponentId()}
							moduleId={props.id}
							x={x}
							classes="bi bi-gear-wide module-icon"
							default=""
							defaultKey={0}
							title='Optionen'
							hiddenInput={true}
							inputIcon='bi-gear-wide'
							onSelect={(key, value) => {
								// ['scroll', 'images', 'content', 'discussion', 'avatar', 'date', 'time']
								switch (key) {
									case 'scroll':
										toggleScroll();
										break;
									case 'images':
										toggleImages();
										break;
									case 'content':
										toggleView();
										break;
									case 'discussion':
										toggleDiscussion();
										break;
									case 'avatar':
										toggleAvatar();
										break;
									case 'date':
										toggleDate();
										break;
									case 'memberColored':
										toggleMemberColored();
										break;
									case 'font':
										toggleFont();
										break;
									case 'startModule':
										setAsStartModule();
										break;
									default:
										break;
								}
							}}
						/>
					</div>
					<div className="forum-postings-column">
						<Postings
							id={'postings-' + props.id}
							forumId={props.forumId}
							x={x}
							classes="d-block"
							chatMode={x.was.chatMode}
							hideContent={hideContent}
							hideDiscussion={hideDiscussion}
							hideImages={hideImages}
							hideAvatar={hideAvatar}
							hideDate={hideDate}
							memberColored={memberColored}
							fontBold={fontBold}
							forumScroll={forumScroll}
							showDialogAnswer={showDialogAnswer}
							moduleId={props.id}
							postingQuote={postingQuote}
							copyToClipboard={copyToClipboard}
							typingMemberName={typingName}
							onRendered={(functions) => {
								x.wam[props.id].postings.load = functions.load;
								x.wam[props.id].postings.scrollToLatest = functions.scrollToLatest;
								x.wam[props.id].postings.render = functions.makePostings;
								x.wam[props.id].postings.setSelectDate = functions.setSelectDate;
								x.wam[props.id].postings.setSelectThread = functions.setSelectThread;
								updateLastPostingNoRead = functions.updateLastPostingNoRead;
								x.wam[props.id].reload = () => {
									functions.load();
								};
							}}
							onLoaded={(postingInfo) => {
								postingCount.current = postingInfo.postingCount;
								setPostingDisplayCount(postingInfo.postingDisplayCount);
							}}
						/>
						{x.was.chatMode &&
							<div className="chat-mode-composer">
								<NewThreadShort
									x={x}
									forumId={props.id}
									onFocus={() => setComposerFocused(true)}
									onBlur={() => setComposerFocused(false)}
								/>
								<i className="bi bi-arrows-angle-expand chat-mode-expand-icon" title="Eingabeformular öffnen" onClick={expandComposer}></i>
								{postingDisplayCount > 0 &&
									<span className={`chat-mode-composer-count ${composerFocused ? 'chat-mode-composer-count-hidden' : ''}`}>
										{postingDisplayCount} {postingDisplayCount === 1 ? 'Beitrag angezeigt' : 'Beiträge angezeigt'}
									</span>
								}
							</div>
						}
					</div>
				</div>

				<Dialog id={answerId} x={x} classes="dialog-new-posting dialog-new-answer " title="Beitrag bearbeiten/antworten" >
					<NewAnswer
						x={x}
						forumId={props.forumId}
						newPostingFunctions={x.wam[props.id].newAnswer}
						moduleId={props.id}
						dialogId={answerId}
						answerTo={answerTo}
						postingQuote={postingQuote}
						copyToClipboard={copyToClipboard}
					/>
				</Dialog>

				<Dialog id={newThreadId} x={x} classes="dialog-new-posting dialog-new-thread" title="Neues Thema" >
					<NewThread
						x={x}
						forumId={props.forumId}
						newPostingFunctions={x.wam[props.id].newThread}
						moduleId={props.id}
						dialogId={newThreadId}
						answerTo={0}
						postingQuote={postingQuote}
					/>
				</Dialog>
				<DialogNewImage
					id={newImageId}
					x={x}
					moduleId={props.id}
					dialogId={newImageId}
				/>
				<Dialog id={currentId} x={x} classes="dialog-postings-list " title="Neueste Beiträge" >
					<PostingList
						id="current-postings"
						x={x}
						forumId={props.forumId}
						moduleId={props.id}
						dialogId={currentId}
						module="Posting"
						task="PostingCurrent"
						postingQuote={postingQuote}
						copyToClipboard={copyToClipboard}
						showDialogAnswer={showDialogAnswer}
						onRendered={(functions) => {
							postingListCurrent.load = functions.searchPostings;
						}}

					/>
				</Dialog>
				<Dialog id={favoritsId} x={x} classes="dialog-postings-list " title="Favoriten" >
					<PostingList
						id={favoritsId + "-listing"}
						x={x}
						forumId={props.forumId}
						moduleId={props.id}
						dialogId={favoritsId}
						module="Posting"
						task="PostingFavorits"
						postingQuote={postingQuote}
						copyToClipboard={copyToClipboard}
						showDialogAnswer={showDialogAnswer}
						onRendered={(functions) => {
							postingListFavorit.load = functions.searchPostings;
						}}

					/>
				</Dialog>
				<Dialog id={searchId} x={x} classes="dialog-search-posting " title="Suchen" >
					<PostingSearch
						x={x}

						forumId={props.forumId}
						moduleId={props.id}
						dialogId={searchId}
						copyToClipboard={copyToClipboard}
						showDialogAnswer={showDialogAnswer}
					/>
				</Dialog>

				<PostingMember
					x={x}
					forumId={props.forumId}
					moduleId={props.id}
					postingMemberId={postingMemberId}
					toggleMember={toggleMember}
					showDialogAnswer={showDialogAnswer}
					copyToClipboard={copyToClipboard}
				/>
				<Dialog id={postingDayId} x={x} classes="dialog-posting-day " title="Gesamten Tag anzeigen" >
					<PostingDay
						x={x}
						forumId={props.forumId}
						moduleId={props.id}
						dialogId={postingDayId}
					/>
				</Dialog>
				<DialogAddLink id={props.id + '-add-link'} x={x} title="Link einfügen" answerTo={answerTo} />
				<DialogAddText id={props.id + '-add-list'} x={x} tag="ul" type="textarea" title="Liste einfügen" answerTo={answerTo} />
				<DialogAddText id={props.id + '-add-text-b'} x={x} tag="b" title="Fett formatierter Text" answerTo={answerTo} />
				<DialogAddText id={props.id + '-add-text-i'} x={x} tag="i" title="Kursiv formatierter Text" answerTo={answerTo} />
				<DialogAddText id={props.id + '-add-text-u'} x={x} tag="u" title="Unterstrichener Text" answerTo={answerTo} />
				<DialogAddText id={props.id + '-add-text-quote'} x={x} tag="quote" title="Zitat" answerTo={answerTo} />
				<DialogSelectText
					id={layoutSettingsId}
					moduleId={props.id}
					x={x}
					onSetData={setLayoutSettingsData}
					classes="dialog-select-layout-settings"
					title="Optionen"
					onRowClasses={(item) => (item.id === '__divider__') ? 'layout-settings-divider-row' : ''}
					onAddColumn={(key, value) => {
						switch (key) {
							case 'icon':
								currentLayoutSettingIcon = value;
								return false;
							case 'name':
								if (currentLayoutSettingIcon === '') return null;
								return (
									<span className="layout-settings-row">
										<i className={`bi ${currentLayoutSettingIcon} module-icon`}></i>
										<span className="layout-settings-row-text">{value}</span>
									</span>
								);
							default:
								return false;
						}
					}}
				/>

				<DialogSelectText
					id={selectTopicId}
					moduleId={props.id} x={x}
					classes="dialog-select-topics"
					onSetData={getTopicList}
					title="Nach Thema filtern"
				/>
			</Module>
		</React.Fragment>
	)
};
